module.exports = __webpack_public_path__ + "static/img/p9.868b9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p9.png
// module id = u8hr
// module chunks = 0